import { closestCenter, CollisionDetection } from '@dnd-kit/core'
import { FormServiceItem } from '../stageTreeUtils'
import { stageLabel } from '../stageNumbering'

export const serviceStageCollisionDetection: CollisionDetection = (args) => {
  const activeId = String(args.active.id)

  if (activeId.startsWith('child:')) {
    const parentKey = activeId.split(':')[1]
    return closestCenter({
      ...args,
      droppableContainers: args.droppableContainers.filter((container) => {
        const id = String(container.id)
        return id.startsWith(`child:${parentKey}:`)
      }),
    })
  }

  if (activeId.startsWith('root:')) {
    return closestCenter({
      ...args,
      droppableContainers: args.droppableContainers.filter((container) =>
        String(container.id).startsWith('root:'),
      ),
    })
  }

  return closestCenter(args)
}

export function resolveServiceDragLabel(
  services: FormServiceItem[],
  dragId: string,
): string | null {
  if (dragId.startsWith('root:')) {
    const rowKey = dragId.slice(5)
    const parentIndex = services.findIndex((s) => s.rowKey === rowKey)
    if (parentIndex < 0) return null
    const service = services[parentIndex]
    return `${stageLabel(parentIndex)} - ${service.service || 'Serviço'}`
  }

  if (dragId.startsWith('child:')) {
    const parts = dragId.split(':')
    if (parts.length < 3) return null
    const parentKey = parts[1]
    const childKey = parts.slice(2).join(':')
    const parentIndex = services.findIndex((s) => s.rowKey === parentKey)
    if (parentIndex < 0) return null
    const children = services[parentIndex].children ?? []
    const childIndex = children.findIndex((c) => c.rowKey === childKey)
    if (childIndex < 0) return null
    const child = children[childIndex]
    return `${stageLabel(parentIndex, childIndex)} - ${child.service || 'Serviço'}`
  }

  return null
}
